import { FormValidationComponent } from 'core/validation/form/form-validation.component'
import {InputValidationComponent} from 'core/validation/input/input-validation.component'
import { Observable, Subject } from 'rxjs'
import {PbmFuncionalService} from './pbm-funcional.service'
import {Message} from 'components/message'
import {PbmFuncionalFormBuilder} from "./pbm-funcional-form.builder";
import {PbmFuncionalPreAuthComponent} from "./pbm-funcional-pre-auth.component"
import { CepComponent } from './cep/cep.component'
import delegate from 'core/delegate'
import { ModalPbmObserver } from '../modal-pbm.observer'
import {ModalPbmComponent} from "../modal-pbm.component";
import { AdicionarCestaObserver } from '../../../cesta/adicionar/adicionarCesta.observer'
import { CestaService } from '../../../cesta/cesta.service'

export class PbmFuncionalCadastroComponent {

  constructor(data) {
    this.data = data;
    this.pbmFuncionalContainer = document.querySelector('#form-container');
    this.funcionalService = new PbmFuncionalService();
    this.pbmFuncionalPreAuth = new PbmFuncionalPreAuthComponent(this.data);
    this.cestaService = new CestaService();
    this.validator;
    this.inputValidator;
    this.buildFormFuncional;
    this.cepComponent;
    this.alert = new Message();
    this.ativaDesconto = document.querySelectorAll('.ativa-desconto')
    this.compraComDesconto = document.querySelectorAll('.compra-com-desconto');
    this.buttonAtivar = document.querySelector('#pbm-form-ativar')
    this.modalPbm = new ModalPbmComponent();
    this.init();
  }

  init() {
    
    if (this.pbmFuncionalContainer) {
      this.buildFormFuncional = new PbmFuncionalFormBuilder(this.pbmFuncionalContainer, this.data);

      if(document.querySelectorAll('[data-entidade="paciente"]').length == 0){
        let titleSpanPaciente = document.querySelector('[data-title="paciente"]')
        if(titleSpanPaciente)titleSpanPaciente.remove();
      }

      this.cepComponent = new CepComponent(this.buildFormFuncional.pbmfuncionalForm);
      this.validator = new FormValidationComponent(this.buildFormFuncional.pbmfuncionalForm, this.buildFormFuncional.validation);
      this.inputValidator = new InputValidationComponent(this.buildFormFuncional.pbmfuncionalForm, this.buildFormFuncional.validation).init();

      let formSubmitStream = Observable.fromEvent(document.querySelector('#pbm-form-funcional'), 'submit');
      formSubmitStream
        .do(event => event.preventDefault())
        .filter(() => this.validator.validateForm())
        .map(event => this.serializeForm())
        .do(formData => this.data.pbm.cadastroFormData = formData)
        .subscribe(data => this.cadastroUnicoRequestNovo(data))
    }
  }


  cadastroUnicoRequestNovo(data){
    data.codigoPrograma = this.data.dadosPbm.sequenciaPrograma;
    data.codigoConvenio = this.data.dadosPbm.codigoConvenio;
    data.codigoAdminConvenio = this.data.dadosPbm.codigoAdminConvenio,
    data.itens = [{
      quantidadeSolicitada: this.data.dadosPbm.quantidadeSolicitada,
      codigoItem: this.data.dadosPbm.item
    }];

    return this.funcionalService.postCadastroUnico(data)
          .subscribe(this.cadastroUnicoResponse())
  }


  cadastroUnicoResponse() {
    return {
        next: response => {
          if(response.status){
            switch(response.status) {
              case 200: {
                this.consultaPrecoResponseSuccess(response.data)
                break;
              }
              default:{

                break;
              }
            }
          }else{
            this.alert.message = "Erro ao validar desconto PBM, tente novamente!";
            this.alert.show();
          }
        },
        error: error => {
          let msg = "Verifique seus dados e tente novamente";
          if(error) {
            if(error.status) {
              if((error.status == 400 || error.status == 404) && error.data && Array.isArray(error.data)){
                msg = error.data.map((elem) => elem.message).join(", ")
              }else if((error.status == 400 || error.status == 404) && error.data && error.data.mensagem){
                msg = error.data.mensagem;
              }

              if(!error.data) msg = "Não foi possível autorizar este item"
            }
          }
          this.alert.message = msg;
          this.alert.show();
        }
    }
  }


  preAutorizarResponse() {
    return {
        next: response => {
          if(response.status){
            switch(response.status) {
              case 200: {
                this.preAutorizarResponseSuccess(response.data)
                break;
              }
              default:{

                break;
              }
            }
          }else{
            this.alert.message = "Erro ao validar desconto PBM, tente novamente!";
            this.alert.show();
          }
        },
        error: error => {
          let msg = "Verifique seus dados e tente novamente";
          if(error) {
            if(error.status) {
              if((error.status == 400 || error.status == 404) && error.data && Array.isArray(error.data)){
                msg = error.data.map((elem) => elem.message).join(", ")
              }else if((error.status == 400 || error.status == 404) && error.data && error.data.mensagem){
                msg = error.data.mensagem;
              }

              if(!error.data) msg = "Não foi possível autorizar este item"
            }
          }

          this.alert.message = msg;
          this.alert.show();
        },
      
    }
  }

  consultaPrecoResponseSuccess(preAutorizacao){
    const numberFormat = Intl.NumberFormat('pt-BR', {style:'currency', currency:'BRL'});

    this.buttonAtivar.id = 'pbm-form-comprar'
    this.buttonAtivar.textContent = 'Comprar com Desconto'

    this.ativaDesconto.forEach(el => {
      el.style.display = 'none'
    });

    this.compraComDesconto.forEach(el => {
      el.style.display = 'block'
    });

    let valorNovo = numberFormat.format((preAutorizacao.itens[0].precoLiquidoPreAutorizado * preAutorizacao.itens[0].quantidadePreAutorizada))
    let valorDesconto = 'Você economiza ' + numberFormat.format((preAutorizacao.itens[0].valorDescontoPreAutorizado * preAutorizacao.itens[0].quantidadePreAutorizada))
    document.getElementById('pbm__valores--novo').textContent = valorNovo.replace('.', ',')
    document.getElementById('pbm__valorDescontoPreAutorizado').textContent = valorDesconto.replace('.', ',')

    this.modalPbm.closeAll()
  }

  preAutorizarResponseSuccess(preAutorizacao){
    let subjectModalSuccess = new Subject();
    subjectModalSuccess.subscribe(new ModalPbmObserver())
    subjectModalSuccess.next(this.buildModalSuccessData(preAutorizacao))

    this.cestaService.getCarrinho().subscribe(new AdicionarCestaObserver());

  }

  buildModalSuccessData(preAutorizacao) {
    const item = this.buildItemFromPreAutorizacao(preAutorizacao);
    const valorAntigo = Number(this.data.dadosPbm.preco).toFixed(2);
    return {
        step: "success",
        valorAntigo: valorAntigo,
        valorNovo: item.precoLiquidoPreAutorizado.toFixed(2),
        valorDesconto: ((valorAntigo - item.precoLiquidoPreAutorizado)).toFixed(2),
        mensagem: (this.data.dadosPbm.quantidadeSolicitada > item.quantidadePreAutorizada) ? this.buildMensagemQuantidade(item) : null
    }
  }

  buildMensagemQuantidade(item) {
      return `Você solicitou ${this.data.quantidadeSolicitada} unidades e foi autorizado ${item.quantidadePreAutorizada} unidades.`
  }

  buildItemFromPreAutorizacao(preAutorizacao) {
      return preAutorizacao
              .itens
              .filter(item => item.codigoItem == this.data.dadosPbm.item)[0]
  }

  serializeForm() {


    const camposBeneficiario = document.querySelectorAll('[data-entidade="beneficiario"]');
    const camposPaciente = document.querySelectorAll('[data-entidade="paciente"]');
    const camposProduto = document.querySelectorAll('[data-entidade="produto"]');
    const camposExtras = document.querySelectorAll('[data-entidade="extras"]');

    let cadastroUnico = {};

    if (camposBeneficiario.length > 0) {
      cadastroUnico.camposBeneficiario = [];

      this.buildCampos(camposBeneficiario, cadastroUnico.camposBeneficiario);
    }
    if (this.data.atributos.utilizaPacientes) {
      cadastroUnico.camposPaciente = [];

      this.buildCampos(camposPaciente, cadastroUnico.camposPaciente, this.data.atributos.utilizaPacientes);
    }
    if (camposProduto.length > 0) {
      cadastroUnico.camposProduto = [];

      this.buildCampos(camposProduto, cadastroUnico.camposProduto);
    }
    if (camposExtras.length > 0) {
      cadastroUnico.camposExtras = [];

      this.buildCampos(camposExtras, cadastroUnico.camposExtras);
    }
    cadastroUnico.cpf = this.data.dadosPbm.nroCpf;
    //cadastroUnico.codigoAdminConvenio = this.data.dadosPbm.codigoAdminConvenio;
    cadastroUnico.ean = this.data.dadosPbm.ean;
    cadastroUnico.precisaCadastroProduto = this.data.atributos.avaliacaoElegibilidade.requisitarCadastroProduto;
    cadastroUnico.precisaCadastroBeneficiario = this.data.atributos.avaliacaoElegibilidade.requisitarCadastroPrograma;
    cadastroUnico.utilizaPaciente = this.data.atributos.utilizaPacientes;
    cadastroUnico.codigoPaciente = this.getCodigoPaciente();

    return cadastroUnico
  }

  buildCampos(array, arrayMount, utilizaPaciente){
    if(!utilizaPaciente) {
      this.pushCampos(array, arrayMount)
    }else {
      let nome = document.querySelector("#input-Nome");
      let sexo = document.querySelector("#select-Sexo");
      let dataNasc = document.querySelector("#input-Nascimento");
      if(nome && sexo && dataNasc) {
        this.buildListaPaciente(arrayMount, nome.value, sexo.value, dataNasc.value)
      }
      this.pushCampos(array, arrayMount)
    }
  }

  pushCampos(array, arrayMount){
    Array.prototype.forEach.call(array, attr => {
      if (attr.value != "") {
        let jsonObj = {};
        jsonObj['campo'] = attr.name.split('-')[0];
        if (attr.type == "checkbox") {
          jsonObj['valor'] = attr.checked;
        } else {
          if(attr.id === "input-Nascimento"){
            let dataNascimento = attr.value.split("/");
            jsonObj['valor'] = `${dataNascimento[1]}/${dataNascimento[0]}/${dataNascimento[2]}`
          }else {
            jsonObj['valor'] = attr.value;
          }
        }
        arrayMount.push(jsonObj);
      }
    });
  }

  buildListaPaciente(arrayMount, nome, sexo, dataNasc) {
    let dataNascimento = dataNasc.split("/");
    let jsonObj1 = {campo: 'Nome', valor: nome};
    let jsonObj2 = {campo: 'Sexo', valor: sexo};
    let jsonObj3 = {campo: 'Nascimento', valor: `${dataNascimento[1]}/${dataNascimento[0]}/${dataNascimento[2]}`};
    let jsonObj4 = {campo: 'Titular', valor: true};

    arrayMount.push(jsonObj1, jsonObj2, jsonObj3, jsonObj4)
  }

  getCodigoPaciente(){
    let codPaciente = null;
    if(this.data.atributos.pacientes) {
      Array.from(this.data.atributos.pacientes, paciente => {
        codPaciente = paciente.codigoPaciente;
      });
    }
    return codPaciente;
  }
}



// WEBPACK FOOTER //
// ./src/main/webapp/assets/js/components/modal/modal-pbm/pbm-funcional/pbm-funcional-cadastro.component.js